const HIGHCHART_TYPES = {
    LINE: 'line',
    COLUMN: 'column',
    SPLINE: 'spline',
    PIE: 'pie',
};

const HIGHCHART_TYPE_OPTIONS = Object.values(HIGHCHART_TYPES).map(type => ({
    label: type.charAt(0).toUpperCase() + type.slice(1),
    value: type,
}));

export { HIGHCHART_TYPE_OPTIONS };
export default HIGHCHART_TYPES;
